import { isAxiosError } from "axios";
import { HttpStatusCode } from "../../common/http-status-code";

let pendingQuestionnairePersistence: Promise<unknown> = Promise.resolve();

function isUnauthorizedError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === HttpStatusCode.UNAUTHORIZED;
}

export function trackQuestionnairePersistence(promise: Promise<unknown>): Promise<unknown> {
  pendingQuestionnairePersistence = promise.catch(function whenFailedToPersistQuestionnaire(error) {
    if (isUnauthorizedError(error)) {
      console.debug("Failed to persist questionnaire", error);
      return undefined;
    }

    console.error("Failed to persist questionnaire", error);
    return undefined;
  });

  return promise;
}

export function awaitPendingQuestionnairePersistence(): Promise<unknown> {
  return pendingQuestionnairePersistence;
}
